<template>
  <v-main>
    <head>
      <!--    TODO add a 'Do you have employees/Does anyone else work here' button, and let users invite other users and add them to the store's employees-->

      <title>Edit your shop - Foraje</title>
      <meta name="description" content="A form to allow you to edit a shop.">
    </head>
    <v-dialog v-model="delete_shop_dialog" max-width="290" >
      <v-card>
        <v-card-title class="headline">Delete {{shop.name}}</v-card-title>
        <v-card-text>If you hit 'Delete this Shop', then {{shop.name}} will be deleted. If that's what you want to do, go ahead and hit Delete, if not, hit cancel, or click outside this window</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click.native="delete_shop_dialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.native="DeleteShop" type="submit">Delete this Shop</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container v-if="isshopdataloading">
      <v-row  >
        <v-col cols="12" class="text-center">
          <v-progress-circular
            :size="100"
            :width="7"
            color="primary"
            indeterminate
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!isshopdataloading">
      <v-form @submit.prevent="ShopUpdate" v-model="is_form_valid">
        <v-card>
          <v-row>
            <v-col cols="12">
              <v-card-title style="justify-content: center">
                <h2>
                Shop Basic Information
                </h2>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  name="name"
                  label="Shop name"
                  id="name"
                  hint="The name of this shop/location"
                  required
                  v-model="shop.name"
                  :disabled="shop_edit_loading"
                />
                <v-text-field
                  name="address"
                  label="Address"
                  id="address"
                  hint="Where is this shop located??"
                  required
                  v-model="shop.address"
                  :disabled="shop_edit_loading"
                />
                <v-textarea
                  name="description"
                  label="Description"
                  id="decription"
                  hint="A Brief description of your shop, an 'about us' section, basically."
                  required
                  v-model="shop.description"
                  :disabled="shop_edit_loading"
                />
                <v-text-field
                name="slug"
                label="Shop URL"
                id="slug"
                ref="slug"
                hint="the URL for your shop. Only Letters, Numbers, Underscores, and Hyphens/dashes are allowed."
                required
                v-model="newshopslug"
                :disabled="shop_edit_loading"
                prefix="https://www.foraje.com/shops/"
                @input="DelayedSlugLookup"
                :error-messages="slugErrorMessages"
                :rules="[slug_rules.min, slug_rules.max, slug_rules.allowed_chars]"
                v-if="shop.approved"
                >
                  <span slot="append">
                    <v-progress-circular v-if="slug_lookup_loading" indeterminate color="green"/>
                    <v-tooltip top v-else-if="slug_available">
        <template v-slot:activator="{ on }">
      <v-icon color="green" v-on="on">mdi-check</v-icon>
        </template>
        <span>This URL is available!</span>
      </v-tooltip>
                    <v-tooltip top v-else-if="invalid_slug">
        <template v-slot:activator="{ on }">
      <v-icon color="red" v-on="on">mdi-cancel</v-icon>
        </template>
        <span>Sorry, not an acceptable URL.</span>
      </v-tooltip>
                    <v-tooltip top v-else>
        <template v-slot:activator="{ on }">
      <v-icon color="red" v-on="on">mdi-cancel</v-icon>
        </template>
        <span>This URL already taken. Sorry!</span>
      </v-tooltip>
                  </span>
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn @click="$router.go(-1)">Cancel</v-btn>
                <v-btn color="primary" :loading="shop_edit_loading" type="submit" :disabled="!slug_available || !is_form_valid">Submit Basic Info

                  <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"/>
                       </span>
                </v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
        <v-card v-if="cleaned_hours && cleaned_hours.length" class="mt-4">
          <v-row>
            <v-col cols="12">
              <v-card-title style="justify-content: center">
                <h2>
                Shop Hours
                </h2>
              </v-card-title>
              <v-card-text v-for="(hour, baseIndex) in cleaned_hours" :key="baseIndex" class="py-0">
                <v-row>
                  <v-col cols="2" class="mt-5">
                    <h3>{{hour.weekday_display}}</h3>
                  </v-col>
                  <v-col cols="auto">
                <v-switch
                  v-model="hour.switch"
                  :label="hour.switch ? 'Open' : 'Closed'"
                  :disabled="hoursloading"
                >
                </v-switch>
                  </v-col>
                  <v-col cols="6" class="pb-1">
                    <v-row v-for="(id, index) in hour.id" :key="index">
                  <v-col cols="4" v-if="hour.switch">
                        <v-autocomplete
                          v-model="hour.open_time[index]"
                          color="primary"
                          label="Opens at"
                          :disabled="hoursloading"
                          :items="times"
                          item-value="value"
                          item-text="display"
                        ></v-autocomplete>
                  </v-col>
                  <span style="align-self: center" v-if="hour.switch">—</span>
                  <v-col cols="5" v-if="hour.switch">
                      <v-autocomplete
                        v-model="hour.close_time[index]"
                        color="primary"
                        label="Closes at"
                        :disabled="hoursloading"
                        :items="times"
                        item-value="value"
                        item-text="display"
                      >
                        <v-btn icon slot="append-outer" text v-if="hour.open_time.length > 1" @click="DeleteHourLine(baseIndex, index)" :disabled="hoursloading"><v-icon>mdi-close</v-icon></v-btn>
                      </v-autocomplete>
                  </v-col>
                      <v-col cols="2" v-if="hour.switch">
                        <v-btn text v-if="hour.open_time[index] && hour.close_time[index] && index === hour.open_time.length - 1" @click="NewHourLine(baseIndex)" :disabled="hoursloading">
                        Add Hours
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
            </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn @click="$router.go(-1)">Cancel</v-btn>
                <v-btn color="primary" :loading="shop_edit_loading" type="submit" :disabled="hoursloading" @click="UpdateHours">Submit Hours

                  <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"/>
                       </span>
                </v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      <v-expansion-panels class="pt-10">
      <v-expansion-panel>
        <v-expansion-panel-header><h2>Delete this shop</h2></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-spacer/>
            <v-btn color="error" @click="delete_shop_dialog = !delete_shop_dialog">Delete</v-btn>
            <v-spacer/>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </v-main>
</template>
<script>
import axios from 'axios';

export default {
  name: 'ShopEdit',
  data: () => ({
    shop: [],
    shoporiginalname: '',

    user: [],

    errors: [],
    change_picture_dialog: false,
    isshopdataloading: false,
    profile_image: null,
    image_submit_loading: false,
    shop_edit_loading: false,
    cleaned_hours: [],
    original_cleaned_hours: [],
    tempid: 0,
    hoursloading: false,
    showhours: false,
    original_slug: '',
    slug_lookup_loading: false,
    typingstopped: false,
    newshopslug: '',
    timeout: null,
    slug_available: true,
    slug_rules: {
      required: value => !!value || 'Required.',
      max: value => value.length <= 200 || 'Max 200 characters',
      min: value => value.length >= 5 || 'Min. 5 characters',
      allowed_chars: (value) => {
        const pattern = /^[a-zA-Z0-9-_]+$/;
        return pattern.test(value) || 'Only Letters, Numbers, Underscores, and Hyphens/dashes are allowed.';
      },
    },
    is_form_valid: false,
    invalid_slug: false,
    delete_shop_dialog: false,

    times: [
      '12:00 AM',
      '12:30 AM',
      '1:00 AM',
      '1:30 AM',
      '2:00 AM',
      '2:30 AM',
      '3:00 AM',
      '3:30 AM',
      '4:00 AM',
      '4:30 AM',
      '5:00 AM',
      '5:30 AM',
      '6:00 AM',
      '6:30 AM',
      '7:00 AM',
      '7:30 AM',
      '8:00 AM',
      '8:30 AM',
      '9:00 AM',
      '9:30 AM',
      '10:00 AM',
      '10:30 AM',
      '11:00 AM',
      '11:30 AM',
      '12:00 PM',
      '12:30 PM',
      '1:00 PM',
      '1:30 PM',
      '2:00 PM',
      '2:30 PM',
      '3:00 PM',
      '3:30 PM',
      '4:00 PM',
      '4:30 PM',
      '5:00 PM',
      '5:30 PM',
      '6:00 PM',
      '6:30 PM',
      '7:00 PM',
      '7:30 PM',
      '8:00 PM',
      '8:30 PM',
      '9:00 PM',
      '9:30 PM',
      '10:00 PM',
      '10:30 PM',
      '11:00 PM',
      '11:30 PM',

    ],
  }),
  methods: {
    FetchShopInfo() {
      const shopSlug = this.$route.params.shopslug;
      this.isshopdataloading = true;
      axios.get(`shops/${shopSlug}/`)
        .then((response) => {
          this.shop = response.data;
          this.original_slug = response.data.slug;
          this.newshopslug = response.data.slug;
          this.cleaned_hours = this.cleanHours(this.shop.hours);
          this.original_cleaned_hours = this.cleanHours(this.shop.hours);
          this.isshopdataloading = false;
          return axios.get(`/image/by/shop/${this.shop.id}/`);
        })
        .then((response) => {
          this.shop_images = response.data.results;
        })
        .then(() => {
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    // takes the shop hours (typically taken from the backend), then takes out the duplicate days, and adds their times onto the matching days. ie instead of tuesday 1-5, tuesday 6-9, you get tuesday 1-5, 6-9
    cleanHours(array) {
      const output = array.reduce((o, cur) => {
        let newO = o;
        // Get the index of the key-value pair.
        const occurs = o.reduce((n, item, i) => ((item.weekday === cur.weekday) ? i : n), -1);

        // If the name is found,
        if (occurs >= 0) {
          // append the current value to its list of values.
          newO[occurs].open_time = newO[occurs].open_time.concat(cur.open_time);
          newO[occurs].close_time = newO[occurs].close_time.concat(cur.close_time);
          newO[occurs].id = newO[occurs].id.concat(cur.id);

          // Otherwise,
        } else {
          // add the current item to o (but make sure the value is an array).
          const obj = {
            weekday: cur.weekday,
            weekday_display: cur.weekday_display,
            open_time: [cur.open_time],
            close_time: [cur.close_time],
            id: [cur.id],
          };
          obj.switch = !!(obj.open_time[0] && obj.open_time[0].length);
          newO = newO.concat([obj]);
        }

        return newO;
      }, []);

      return output;
    },
    NewHourLine(weekday) {
      this.cleaned_hours[weekday].open_time.push('');
      this.cleaned_hours[weekday].close_time.push('');
      this.cleaned_hours[weekday].id.push(0);
    },
    DeleteHourLine(weekday, index) {
      const authheader = `Token ${this.$store.getters.token}`;
      if (this.cleaned_hours[weekday].id[index] !== 0) {
        axios.patch(`forms/products/shops/hours/update/${this.cleaned_hours[weekday].id[index]}/`, {
          is_active: false,
        },
        {
          headers: {
            Authorization: authheader,
          },
        });
      }
      this.cleaned_hours[weekday].open_time.splice(index, 1);
      this.cleaned_hours[weekday].close_time.splice(index, 1);
      this.cleaned_hours[weekday].id.splice(index, 1);
    },
    UpdateHours() {
      const authheader = `Token ${this.$store.getters.token}`;
      let disablecounter = 0;
      let hourcounter = 0;
      let weekdaycounter = 0;
      let loopscompleted = 0;
      this.cleaned_hours.forEach((weekday, index, array) => {
        if (weekday.switch === false) {
          // if database side open_time is not null, to avoid constant reldeleting of closed days with null data.
          Object.keys(weekday.id).forEach((key) => {
            if (this.original_cleaned_hours[index].open_time[key]) {
              axios.patch(`forms/products/shops/hours/update/${weekday.id[key]}/`, {
                is_active: false,
              },
              {
                headers: {
                  Authorization: authheader,
                },
              })
                .then(() => {
                  disablecounter += 1;
                })
                .then(() => {
                  if (disablecounter >= Object.keys(weekday.id).length) { weekdaycounter += 1; disablecounter = 0; }
                })
                .then(() => {
                  if (weekdaycounter >= array.length) {
                    this.$router.push(`/shops/${this.shop.slug}`);
                  }
                });
            } else {
              disablecounter += 1;
              if (disablecounter >= Object.keys(weekday.id).length) { weekdaycounter += 1; disablecounter = 0; }
              if (weekdaycounter >= array.length) {
                this.$router.push(`/shops/${this.shop.slug}`);
              }
            }
          });
          // axios.patch('forms/products/shop/hours/update/<int:pk>')
        } else if (weekday.switch === true) {
          Object.keys(weekday.id).forEach((key) => {
            if (weekday.id[key] !== 0) {
              axios.patch(`forms/products/shops/hours/update/${weekday.id[key]}/`, {
                open_time: weekday.open_time[key],
                close_time: weekday.close_time[key],
              },
              {
                headers: {
                  Authorization: authheader,
                },
              })
                .then(() => {
                  hourcounter += 1;
                })
                .then(() => {
                  if (hourcounter >= Object.keys(weekday.id).length) { weekdaycounter += 1; hourcounter = 0; }
                })
                .then(() => {
                  if (weekdaycounter >= array.length) {
                    this.$router.push(`/shops/${this.shop.slug}`);
                  }
                });
            } else {
              axios.post('forms/products/shops/hours/create/', {
                open_time: weekday.open_time[key],
                close_time: weekday.close_time[key],
                weekday: weekday.weekday,
                shop: this.shop.slug,
              },
              {
                headers: {
                  Authorization: authheader,
                },
              })
                .then(() => {
                  hourcounter += 1;
                })
                .then(() => {
                  if (hourcounter >= Object.keys(weekday.id).length) { weekdaycounter += 1; hourcounter = 0; }
                })
                .then(() => {
                  if (weekdaycounter >= array.length) {
                    this.$router.push(`/shops/${this.shop.slug}`);
                  }
                });
            }
          });
        }
        // I know it's hacky, but I cant figure out where the above counter system was breaking, so this should work as a 'temporary' fix. I know it'll probably be left for a while (forever). My bad.
        loopscompleted += 1;
        if (loopscompleted >= array.length) {
          setTimeout(() => this.GoToShopPage(), 3000);
        }
      });
    },
    ShopUpdate() {
      const authheader = `Token ${this.$store.getters.token}`;
      const shopslug = this.shop.slug;
      axios.patch(`forms/products/shops/update/${shopslug}/`, {
        name: this.shop.name,
        address: this.shop.address,
        description: this.shop.description,
        slug: this.newshopslug,
      },
      {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.GoToShopPage(response.data.slug);
        })
        .catch(() => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong when trying to update this shop. We\'ll fix it, sorry for the hassle.', alert_model: true,
          });
        });
    },
    GoToShopPage(slug) {
      if (this.$route.path !== `/shops/${slug}`) { this.$router.push(`/shops/${slug}`); }
    },

    CheckSlugAvailability(slug) {
      const pattern = /^[a-zA-Z0-9-_]+$/;
      if (slug.match(pattern)) {
        this.slug_lookup_loading = true;
        this.invalid_slug = false;
        axios.get(`lookup/shop/slug/${slug}/`)
          .then(() => {
            this.slug_lookup_loading = false;
            this.slug_available = this.shop.slug === this.newshopslug;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              this.slug_lookup_loading = false;
              this.slug_available = true;
            }
            return error;
          });
      } else { this.slug_available = false; this.slug_lookup_loading = false; this.invalid_slug = true; }
    },
    DelayedSlugLookup() {
      this.slug_lookup_loading = !this.slug_lookup_loading;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.CheckSlugAvailability(this.newshopslug);
      }, 750);
    },
    DeleteShop() {
      const authheader = `Token ${this.$store.getters.token}`;
      const shopslug = this.shop.slug;
      axios.patch(`forms/products/shops/update/${shopslug}/`, {
        is_active: false,
      },
      {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.$router.push('/user/shops/');
        })
        .then(() => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Shop deleted!',
            alert_model: true,
          });
        })
        .catch(() => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong when trying to delete this shop. We\'ll fix it, sorry for the hassle.', alert_model: true,
          });
        });
    },
  },

  created() {
    this.FetchShopInfo();
  },
  computed: {
    slugErrorMessages() {
      if (!this.invalid_slug && !this.slug_available) {
        return 'Sorry, that URL is already taken.';
      }
      // return 'Something is wrong with that URL, try another one!';
      return null;
    },
  },
};
</script>

<style scoped>

</style>
